import React, { useState, useRef, useEffect } from "react";
import { GoogleMap, LoadScript, Polygon, Circle, Rectangle, DrawingManager } from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "500px",
};

const center = {
  lat: 1.3521,
  lng: 103.8198,
};

// Predefined shapes
const defaultShapes = []; /* [
  {
    id: 1,
    type: "polygon",
    path: [
    {
        "lat": 1.3755013056661642,
        "lng": 103.775492285439
    },
    {
        "lat": 1.3418651357950808,
        "lng": 103.75437793607377
    },
    {
        "lat": 1.3192119436989616,
        "lng": 103.76948413724564
    },
    {
        "lat": 1.3120040664271877,
        "lng": 103.83402881498002
    },
    {
        "lat": 1.3257333384787426,
        "lng": 103.90543994779252
    },
    {
        "lat": 1.3583400530214678,
        "lng": 103.89514026517533
    },
    {
        "lat": 1.383567051866779,
        "lng": 103.85960636014603
    },
    {
        "lat": 1.3885437752135306,
        "lng": 103.83660373563431
    },
    {
        "lat": 1.3837386631907005,
        "lng": 103.78785190457963
    }
],
    editable: true,
  }
] */

const GoogleMapComponent = ({onShapesUpdate, zoneCoordinationPoint}) => {
  const [shapes, setShapes] = useState(zoneCoordinationPoint);
  const shapeRefs = useRef({});
  const timeoutRef = useRef(null);
  const timeoutRef2 = useRef(null);
  const timeoutRef3 = useRef(null);



  // Assign shape references correctly
  const onLoad = (shape, id) => {
    shapeRefs.current[id] = shape;
  };

  // Handle shape modification
  const onPolygonEdit = (id) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current); // Clear previous timeout
    }
    timeoutRef.current = setTimeout(() => {
    const polygon = shapeRefs.current[id];
    if (!polygon) return;

    const updatedPath = polygon
      .getPath()
      .getArray()
      .map((latLng) => ({ lat: latLng.lat(), lng: latLng.lng() }));

    setShapes((prevShapes) =>
      prevShapes.map((shape) => (shape.id === id ? { ...shape, path: updatedPath } : shape))
    );
    setTimeout(() => {
      onShapesUpdate('zoneCoordinationPoint', shapes)
    }, 1000); 
    console.log('checkinggg')
   
  }, 1000); 
  };

  const onCircleEdit = (id) => {
    if (timeoutRef2.current) {
      clearTimeout(timeoutRef2.current); // Clear previous timeout
    }
    timeoutRef2.current = setTimeout(() => {
    const circle = shapeRefs.current[id];
    if (!circle) return;

    const updatedCenter = { lat: circle.getCenter().lat(), lng: circle.getCenter().lng() };
    const updatedRadius = circle.getRadius();

    setShapes((prevShapes) =>
      prevShapes.map((shape) =>
        shape.id === id ? { ...shape, center: updatedCenter, radius: updatedRadius } : shape
      )
    );
    
  }, 1000); 
  };

  const onRectangleEdit = (id) => {
    if (timeoutRef3.current) {
      clearTimeout(timeoutRef3.current); // Clear previous timeout
    }
    timeoutRef3.current = setTimeout(() => {
      const rectangle = shapeRefs.current[id];
      if (!rectangle) return;

      const updatedBounds = {
        north: rectangle.getBounds().getNorthEast().lat(),
        east: rectangle.getBounds().getNorthEast().lng(),
        south: rectangle.getBounds().getSouthWest().lat(),
        west: rectangle.getBounds().getSouthWest().lng(),
      };
      console.log('dsadasdada')
      setShapes((prevShapes) =>
        prevShapes.map((shape) => (shape.id === id ? { ...shape, bounds: updatedBounds } : shape))
      );
    }, 1000); // Delay update by 500ms
  };

  return (
    <LoadScript googleMapsApiKey="AIzaSyDGQXHovgvrezgJb3hHQj1uElQBLAchnaU" libraries={["drawing"]}>
      <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={13}>
        {/* Render & Edit Shapes */}
        {shapes.map((shape) =>
          shape.type === "polygon" ? (
            <Polygon
              key={shape.id}
              paths={shape.path}
              options={{ editable: shape.editable, draggable: true, fillColor: "blue", strokeColor: "black" }}
              onMouseUp={() => onPolygonEdit(shape.id)}
              onLoad={(polygon) => onLoad(polygon, shape.id)}
            />
          ) : shape.type === "circle" ? (
            <Circle
              key={shape.id}
              center={shape.center}
              radius={shape.radius}
              options={{ editable: shape.editable, draggable: true, fillColor: "red" }}
             /*  onCenterChanged={() => onCircleEdit(shape.id)} */
              onRadiusChanged={() => onCircleEdit(shape.id)}
              onLoad={(circle) => onLoad(circle, shape.id)}
            />
          ) : shape.type === "rectangle" ? (
            <Rectangle
              key={shape.id}
              bounds={shape.bounds}
              options={{ editable: shape.editable, draggable: true, fillColor: "green" }}
              /* onBoundsChanged={() => onRectangleEdit(shape.id)} */
              onLoad={(rectangle) => onLoad(rectangle, shape.id)}
            />
          ) : null
        )}

        {/* Drawing Manager to Add New Shapes */}
        <DrawingManager
          options={{
            drawingControl: true,
            drawingControlOptions: {
              position: window.google?.maps.ControlPosition.TOP_CENTER,
              drawingModes: ["polygon"],
            },
          }}
          onPolygonComplete={(polygon) => {
            const newPath = polygon
              .getPath()
              .getArray()
              .map((latLng) => ({ lat: latLng.lat(), lng: latLng.lng() }));
            console.log(newPath, 'newPathnewPath')
            
            setShapes([...shapes, { id: shapes.length + 1, type: "polygon", path: newPath, editable: true }]);
            onShapesUpdate('zoneCoordinationPoint', [...shapes, { id: shapes.length + 1, type: "polygon", path: newPath, editable: true }])
          }}
          onCircleComplete={(circle) => {
            const newCircle = {
              id: shapes.length + 1,
              type: "circle",
              center: { lat: circle.getCenter().lat(), lng: circle.getCenter().lng() },
              radius: circle.getRadius(),
              editable: true,
            };
            setShapes([...shapes, newCircle]);
          }}
          onRectangleComplete={(rectangle) => {
            const bounds = rectangle.getBounds();
            const newRectangle = {
              id: shapes.length + 1,
              type: "rectangle",
              bounds: {
                north: bounds.getNorthEast().lat(),
                east: bounds.getNorthEast().lng(),
                south: bounds.getSouthWest().lat(),
                west: bounds.getSouthWest().lng(),
              },
              editable: true,
            };
            setShapes([...shapes, newRectangle]);
          }}
        />
      </GoogleMap>
    </LoadScript>
  );
};

export default GoogleMapComponent;
